document.addEventListener("DOMContentLoaded", function(){

  const popup = document.getElementById("kamello-popup");
  const closeBtn = popup.querySelector(".kamello-close");
  const form = popup.querySelector("#kamello-form");
  const success = popup.querySelector(".kamello-success");

  if(!sessionStorage.getItem("kamelloPopupShown")){
    setTimeout(() => {
      popup.classList.add("show");
      sessionStorage.setItem("kamelloPopupShown","true");
    },3000);
  }

  closeBtn.addEventListener("click", () => {
    popup.classList.remove("show");
  });

  popup.addEventListener("click", (e) => {
    if(e.target === popup){
      popup.classList.remove("show");
    }
  });

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    form.style.display = "none";
    success.style.display = "block";

    setTimeout(() => {
      window.location.replace("/discount/SIPWITHUS10?redirect=/collections/all");
    },500);
  });

});